export default __webpack_public_path__ + "static/media/pg-27.25616627.jpg";